<template>
  <div class="main-side">
    <div class="main-side-toolbar" @click="onBackTop">
      <a class="option-box" id="backTop" data-type="backtop">
        <img src="~@/assets/img/backtop.png" alt="" srcset="">
        <span class="show-txt">
          返回
          <br>
          顶部
        </span>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    scrollPos: {
      type: Number,
      require: true,
      default: 0
    },
    scrollContainerId: {
      type: String,
      require: true,
      default: ''
    },
  },
  data() {
    return {
      backTop: undefined
    };
  },
  watch: {
    scrollPos(val) {
      if (val) {
        if(val > 1000) {
          this.removeClass(this.backTop, 'back-top-hidden')
        } else {
          this.addClass(this.backTop, 'back-top-hidden')
        }
      }
    },
  },
  mounted() {
    this.backTop = document.getElementById('backTop');
    this.addClass(this.backTop, 'back-top-hidden');
  },
  created() {
    
  },
  methods: {
    onBackTop() {
      let scrollContainer = document.getElementById(this.scrollContainerId);
      scrollContainer.scrollTo(0, 0);
      this.backTop = document.getElementById('backTop');
      this.addClass(this.backTop, 'back-top-hidden');
    },
  }
};
</script>

    
<style lang="less" scoped>
.main-side {
  padding: 0;
  margin: 0;
}

.main-side-toolbar {
  position: fixed;
  right: 24px;
  bottom: 30px;
  width: 44px;
  outline: 0;
  z-index: 2000;

  a.option-box {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    opacity: 1;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 50%;
    background: #000;
    -webkit-box-shadow: 4px 6px 8px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 4px 6px 8px 0 rgba(0, 0, 0, 0.5);;
    background-color: #fff;
    text-align: center;
    height: 44px;
    cursor: pointer;
    margin-top: 8px;
    text-decoration: none;
    outline: none;
    padding: 0;
    margin: 0;
    font-weight: normal;
    -webkit-box-sizing: border-box;
    -webkit-transition: opacity .6s ease-in-out;
    transition: opacity .6s ease-in-out;

    img {
      display: block;
      width: 24px;
      border: 0;
      outline: none;
      box-sizing: inherit;
      overflow-clip-margin: content-box;
      overflow: clip;
      -webkit-transition: opacity .6s ease-in-out;
      transition: opacity .6s ease-in-out;
    }

    .show-txt {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 50%;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      font-size: 12px;
      line-height: 14px;
      color: #999aaa;
      background-color: #fff;
      text-align: center;
      opacity: 0;
      -webkit-transition: opacity .6s ease-in-out;
      transition: opacity .6s ease-in-out;
    }
  }

  a.option-box:hover {
    img {
      display: none;
      opacity: 0;
    }

    .show-txt {
      display: flex;
      opacity: 1;
    }
  }

  .back-top-hidden {
    opacity: 0!important;
    -webkit-transition: opacity .6s ease-in-out;
    transition: opacity .6s ease-in-out;
  }
}
</style>